import React from "react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#15152b] px-6 md:px-10 py-12"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="flex items-center gap-3">
          <span className="relative inline-flex h-8 w-8 items-center justify-center rounded-md bg-stormly-cyan/20">
            <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4 text-stormly-cyan">
              <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" fill="currentColor" />
            </svg>
          </span>
          <div>
            <p className="font-heading font-black text-lg leading-none">Stormly</p>
            <p className="text-xs text-white/50 mt-1">Web Design Agency</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-white/60">
          <a href="#uslugi" className="hover:text-white transition-colors">Usługi</a>
          <a href="#portfolio" className="hover:text-white transition-colors">Portfolio</a>
          <a href="#proces" className="hover:text-white transition-colors">Proces</a>
          <a href="#kontakt" className="hover:text-white transition-colors">Kontakt</a>
        </div>

        <div className="text-sm text-white/40">
          © {new Date().getFullYear()} Stormly. Wszystkie prawa zastrzeżone.
        </div>
      </div>
    </footer>
  );
};
